/**
 * 关闭视图
 * 目前适用于卡牛，随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'

export default () => {
  if (useragent.isSuishouji) {
    call(uriSuishouji('closeView'))
  } else if (useragent.isKaniu) {
    call('cardniu://app/webview/close')
  } else if (useragent.isSuiguanjia) {
    call('sgj://app/webview/close');
  }
}
